import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import { createLoadListReducerWithBegin } from '../../utils/getCrudConfig';
import { USER_ACTION_LOG_PAGE_MODULE } from '../../configs/moduleNames';
import { LOAD_USER_ACTION_LIST } from './actions';

const initialState = {
  loadingUserActionList: false,
  userActionList: [],
  userActionListMeta: [],
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(USER_ACTION_LOG_PAGE_MODULE + LOAD_USER_ACTION_LIST, 'userActionList', 'loadingUserActionList'),
}, initialState);

export default reducer;

export const getUserActionData = createSelector(
  [state => state[USER_ACTION_LOG_PAGE_MODULE]],
  state => {
    const {
      userActionList,
      userActionListMeta,
      loadingUserActionList,
    } = state;

    return {
      userActionList,
      userActionListMeta,
      loadingUserActionList,
    };
  },
);
